import { combineReducers } from 'redux';
import accountReducers from './accountReducers';
import termsAndConditionsReducer from './termsAndConditionsReducer';
import snackBarReducer from './snackBarReducer';
import connectionReducer from '../../components/TrustCenter/store/reducers/connectionReducer';
import agreementReducer from '../../components/TrustCenter/store/reducers/agreementDetailsReducer';
import headerReducer from './headerReducer';
import sessionReducers from './sessionReducers';
import fuelVendorReducer from '../../components/FuelVendor/store/reducers/fuelVendorReducer';
import sharingAgreementsReducers from './sharingAgreementsReducers';
import visibilityProviderConfigReducer from 'components/TrustCenter/store/reducers/visibilityProviderConfigReducer';
import agreementV2Reducer from 'components/TrustCenter/store/reducers/agreementV2Reducer';
export default combineReducers({
    session: sessionReducers,
    header: headerReducer,
    accounts: accountReducers,
    termsAndConditions: termsAndConditionsReducer,
    snackBar: snackBarReducer,
    connection: connectionReducer,
    agreement: agreementReducer,
    fuelVendor: fuelVendorReducer,
    sharingAgreements: sharingAgreementsReducers,
    carrierConfig: visibilityProviderConfigReducer,
    agreementV2: agreementV2Reducer
});
